<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <el-form ref="ruleForm" :model="notice" label-position="right" class="mainfrom">
        <div v-if="!notice.porjectid">
          <el-form-item label="菜单">
            {{notice.wmenu.wmenuname}}
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item label="主题" prop="noticetitle" verify>
            <el-input v-model="notice.noticetitle" :maxlength="255" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="附件文件">
          <el-link
              v-if="type == 3"
              type="primary"
              @click="downFile (notice.noticeurl)"
              target="_blank"
              :underline="false"
            >
              {{notice.noticefilename}}
          </el-link>
          <upload-file
            v-else
            @changed='setfile'
            :appendUrl='notice.noticeurl'
            :appendName="notice.noticefilename"
            text="选择文件"></upload-file>

        </el-form-item>
        
        <el-form-item label="是否弹窗" v-if="+notice.noticewmenuid === 56">
          <el-checkbox v-model="notice.popflg"></el-checkbox>
        </el-form-item>
        <div class="from_input row" v-if="!notice.porjectid">
          <!-- <el-form-item label="开始时间" prop="noticebegtime" verify>/ -->
          <el-form-item label="开始时间" prop="noticebegtime">
            <el-date-picker v-model="notice.noticebegtime" type="datetime" placeholder="选择日期时间"
                            :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="截止时间" prop="noticeendtime" :verify="validateend"> -->
          <el-form-item label="截止时间" prop="noticeendtime">
            <el-date-picker v-model="notice.noticeendtime" type="datetime" placeholder="选择日期时间"
                            :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <span style="color:red;">（时间未填写则表示公告无限期展示）</span>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item label="内容">
            <div v-if="type == 3">
              <div v-html="notice.noticedesc"  style="margin-top:-12px"></div>
            </div>
            <div v-else>
                <div ref="editor" style="text-align:left"></div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import E from 'wangeditor'
  import config from '../../assets/config'
  import uploadFile from '../common/uploadFile'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'

  export default {
    name: "noticeform",
    mixins: [common],
    data () {
      return {
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() <= Date.now() - 86400000
          }
        },
        notice: this.$route.params.form,
        project: {},
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        editorContent: '',
        editor: '',
      }
    },
    created () {
    },
    async activated () {
      this.init()
      if(this.type != 3){
        await this.initEditor()
      }
    },
    mounted () {
      // this.initEditor()
    },
    watch: {
      $route (to, from) {
        to.name === 'noticeForm'
      }
    },
    filters: {},
    components: {uploadFile},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    deactivated () {
      this.$destroy()
    },
    methods: {
      validateend (rule, val, callback) {
        if (dayjs(val).valueOf() <= dayjs(this.notice.noticebegtime).valueOf()) {
          callback(Error('截止时间不能小于等于开始时间'))
        } else {
          callback()
        }
      },
      initEditor () {
        if (this.editor) {
          this.editor.txt.html(this.$route.params.form.noticedesc)
          return
        }
        this.editor = new E(this.$refs.editor)
        this.editor.config.onchange = (html) => {
          this.editorContent = html
        }
        this.editor.config.uploadFileName = 'file'
        this.editor.config.uploadImgServer = `${config.baseUrl}upload/upload`
        this.editor.config.zIndex = 1
        this.editor.create()
        this.editor.txt.html(this.$route.params.form.noticedesc)
      },
      async init () {
        this.notice = this.$route.params.form
        this.editorContent = this.$route.params.form.noticedesc
        this.notice.popflg = this.notice.popflg?true:false
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.wmenuList = []
        this.notice.noticfromid = this.notice.wmenu.noticfromid
        // if (this.notice.wmenu.project) {
        //   this.disable = true
        // }
      },
      async setfile (path, filename) {
        this.notice.noticeurl = path.replace(this.uploadAddr, '')
        this.notice.noticefilename = filename
      },
      async addOrEdit () {

        this.submitForm('ruleForm').then(async() => {
          this.notice.noticebegtime = utils.formatterDate(this.notice.noticebegtime, 'yyyy-MM-dd HH:mm:ss')
          this.notice.noticeendtime = utils.formatterDate(this.notice.noticeendtime, 'yyyy-MM-dd HH:mm:ss')
          this.notice.noticecosid = this.$store.getters.loginUser.cosid
          this.notice.noticedesc = this.editorContent
          let data = await request({
            url: '/ywgl/notice/addOrEdit',
            method: "post",
            data: this.notice
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
      },
      close () {
        console.log('this.$route.name', this.$route.name)

        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'noticeIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";

  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 690px;
    }
    .file {
      display: flex;
      flex-direction: column;
      width: 50%;
    }
  }
</style>

